import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Tooltip} from "reactstrap";
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import AdminForm from "../AdminForm";
import {connect} from "react-redux";
import api from "../../../../../api";

class EditAction extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tooltip: false,
      modal: false,
      loading: false,
      errors: {}
    };

    this.userForm = React.createRef();
    this.updateUser = this.updateUser.bind(this);
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]})
  }

  updateUser(e, data) {
    e.preventDefault();
    this.setState({loading: true});

    api.user.patch.admin(this.props.user.id, data.user)
    .then(() => {
      this.props.handleChange();
      this.setState({
        loading: false,
        modal: false
      })
    }).catch(e => {
      console.log('e', e);
      this.setState({
        loading: false,
        errors: _.has(e, 'response.data.form.errors') ? e.response.data.form.errors : {},
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <span id={'editUser-' + this.props.user.id} className="fas fa-user-edit mr-2" onClick={() => this.toggle('modal')}/>
        <Tooltip
          delay={0}
          placement="bottom"
          isOpen={this.state.tooltip}
          target={'editUser-' + this.props.user.id}
          toggle={() => this.toggle('tooltip')}
        >Edytuj</Tooltip>

        <Modal isOpen={this.state.modal} size="lg" toggle={() => this.toggle('modal')}>
          <ModalHeader toggle={() => this.toggle('modal')} tag="h2">Edycja</ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <AdminForm user={this.props.user} errors={this.state.errors} onSubmit={this.updateUser} ref={this.userForm}/>
          </ModalBody>
          <ModalFooter>
            <div className="direction-group d-flex justify-content-end">
              <div className="direction-right">
                <FormattedMessage id="_.button.save">{
                  (message) => <LaddaButton
                    className="btn btn-success btn-ladda mb-0 ml-3"
                    data-style={ZOOM_OUT}
                    onClick={e => this.updateUser(e, this.userForm.current.state)}
                    loading={this.state.loading}
                  >
                    {message}
                  </LaddaButton>
                }</FormattedMessage>
                <FormattedMessage id="_.button.cancel">{
                  (message) => <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggle('modal')}>{message}</Button>
                }</FormattedMessage>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    )
  }
}

EditAction.propTypes = {
  user: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null )(EditAction);